import React from 'react';
import { ArrowRightIcon, ArrowLeftIcon, CheckIcon } from '@heroicons/react/24/outline';

function Icon({ name, className }) {
  const iconClass = className || 'w-5 h-5';
  switch (name) {
    case 'users':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case 'building':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 21h18" />
          <path d="M6 21V8l6-3 6 3v13" />
          <path d="M9 21v-6h6v6" />
        </svg>
      );
    case 'handshake':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M4 13l4 4a3 3 0 0 0 4.2 0L22 7" />
          <path d="M16 7h6v6" />
          <path d="M8 17H2v-6" />
        </svg>
      );
    case 'user-plus':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="10" cy="7" r="4" />
          <line x1="19" y1="8" x2="19" y2="14" />
          <line x1="16" y1="11" x2="22" y2="11" />
        </svg>
      );
    case 'user-check':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="10" cy="7" r="4" />
          <path d="M16 11l2 2 4-4" />
        </svg>
      );
    case 'user-cog':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="10" cy="7" r="4" />
          <circle cx="19" cy="13" r="2" />
          <path d="M19 9v1M19 15v1M16.6 10.6l.7.7M20.7 14.7l.7.7M20.7 11.3l-.7.7M17.3 14.7l-.7.7" />
        </svg>
      );
    case 'pie-chart':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
          <path d="M22 12A10 10 0 0 0 12 2v10z" />
        </svg>
      );
    case 'briefcase':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
      );
    case 'git-merge':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="18" cy="18" r="3" />
          <circle cx="6" cy="6" r="3" />
          <path d="M6 21V9a9 9 0 0 0 9 9" />
        </svg>
      );
    case 'file-signature':
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <path d="M12 18c-1.5 0-2.5-1-3-2l1.5-1.5c.3.6.9 1 1.5 1s1.2-.4 1.5-1l1.5 1.5c-.5 1-1.5 2-3 2z" />
        </svg>
      );
    default:
      return (
        <svg className={iconClass} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
        </svg>
      );
  }
}

function getGoalMetadata(goalName) {
  const iconMap = {
    'Find a Successor': 'users',
    'Selling my practice': 'building',
    'Selling part of my practice': 'pie-chart',
    'Buying': 'briefcase',
    'Merging': 'git-merge',
    'Partnering': 'handshake',
    'Become a Successor': 'user-check',
    'Forming a Partnership': 'file-signature',
    'Finding a Junior Partner': 'user-plus',
    'Becoming a Junior Partner': 'user-cog',
  };

  return {
    iconName: iconMap[goalName] || 'users',
  };
}

export default function StepGoals({ options, selected, onToggle, onNext, onBack, businessType }) {
  const brandedName = (typeof document !== 'undefined' && document.store?.getState?.()?.company?.branded_name) || 'Practice Exchange';

  // Transform goal name display: replace "practice" with "business" for p_and_c companies
  const getDisplayName = (goalName) => {
    if (businessType === 'p_and_c') {
      return goalName.replace(/practice/gi, 'business');
    }
    return goalName;
  };

  return (
    <div className="w-full px-8 py-12 sm:px-12 sm:py-16 flex flex-col max-h-[90vh]">
      <div className="w-full max-w-4xl mx-auto flex flex-col flex-1 min-h-0">
        {/* Header */}
        <div className="text-center mb-12 flex-shrink-0">
          <h2 className="text-4xl sm:text-5xl font-semibold text-gray-900 mb-4 tracking-tight">
            What do you want to do with {brandedName}
          </h2>
          <p className="text-lg text-gray-500">Choose all that apply</p>
        </div>

        {/* Scrollable options */}
        <div className="flex-1 min-h-0 overflow-y-auto pr-2 -mr-2 mb-8">
          <div className="flex flex-wrap gap-3 justify-center">
            {options.map((goal) => {
              const checked = selected.includes(goal.id);
              const { iconName } = getGoalMetadata(goal.name);
              const displayName = getDisplayName(goal.name);

              return (
                <button
                  key={goal.id}
                  onClick={() => onToggle(goal.id)}
                  className={`inline-flex items-center gap-2.5 px-6 py-3.5 rounded-full border-2 transition-all duration-200 group
                    ${
                      checked
                        ? 'text-white shadow-lg scale-105'
                        : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300 hover:shadow-md'
                    }`}
                  style={checked ? {
                    backgroundColor: 'var(--succession-primary, var(--company-primary, #5489B6))',
                    borderColor: 'var(--succession-primary, var(--company-primary, #5489B6))'
                  } : {}}
                >
                  <Icon name={iconName} className="w-5 h-5" />

                  <span className="font-medium text-base">{displayName}</span>
                  {checked && <CheckIcon className="w-5 h-5 ml-1" />}
                </button>
              );
            })}
          </div>
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center flex-shrink-0 pt-4 border-t border-gray-100">
          <button
            onClick={onBack}
            className="inline-flex items-center gap-2 px-6 py-3 text-gray-600 font-medium hover:text-gray-900 transition-colors duration-200 group"
          >
            <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200" />
            Back
          </button>
          <button
            disabled={selected.length < 1}
            onClick={onNext}
            className="inline-flex items-center gap-2 px-8 py-3 text-white font-medium disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-200 disabled:hover:opacity-30 group rounded-full"
            style={{
              backgroundColor: 'var(--succession-primary, var(--company-primary, #5489B6))'
            }}
            onMouseEnter={(e) => {
              if (!e.target.disabled) {
                e.target.style.opacity = '0.9';
              }
            }}
            onMouseLeave={(e) => {
              if (!e.target.disabled) {
                e.target.style.opacity = '1';
              }
            }}
          >
            Continue
            <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </button>
        </div>
      </div>
    </div>
  );
}


